export const ComponentAccordionBg = '#ffffff';
export const ComponentAccordionFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentAccordionBorderColor = '#b2b2b2';
export const ComponentAccordionSummaryColor = '#005ba8';
export const ComponentAccordionSummaryIconColor = '#005ba8';
export const ComponentAccordionSummaryFocusBorder = '#005ba8';
export const ComponentAccordionSummaryHoverColor = '#ebf6ff';
export const ComponentActionFontSizeLg = '18px';
export const ComponentActionFontSizeMd = '16px';
export const ComponentActionFontSizeSm = '14px';
export const ComponentActionFontSizeXs = '12px';
export const ComponentActionFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentActionColor = '#005ba8';
export const ComponentActionHover = '#318ad3';
export const ComponentActionDisabled = '#959595';
export const ComponentActionFocusBorder = '#005ba8';
export const ComponentActionShadowColor = '#cce8ff';
export const ComponentAlertBorder = '#959595';
export const ComponentAlertFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentAlertFontWeight = '400';
export const ComponentAlertFontSize = '14px';
export const ComponentAlertFontLineHeight = '130%';
export const ComponentAlertFontColor = '#000000';
export const ComponentAlertTitleFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentAlertTitleFontWeight = '600';
export const ComponentAlertTitleFontSize = '14px';
export const ComponentAlertTitleFontLineHeight = '120%';
export const ComponentAlertTitleFontColor = '#000000';
export const ComponentAlertLinkFontWeight = '500';
export const ComponentAlertCloseButtonColor = '#5a5a5a';
export const ComponentAlertCloseButtonRadius = '4px';
export const ComponentAlertCloseButtonSvgSize = '16px';
export const ComponentAlertErrorBg = '#ffffff';
export const ComponentAlertErrorRadius = '4px';
export const ComponentAlertErrorBorder = '#d41e27';
export const ComponentAlertErrorLinkColor = '#005ba8';
export const ComponentAlertInfoBg = '#ffffff';
export const ComponentAlertInfoRadius = '4px';
export const ComponentAlertInfoBorder = '#2372b8';
export const ComponentAlertInfoLinkColor = '#005ba8';
export const ComponentAlertSuccessBg = '#ffffff';
export const ComponentAlertSuccessRadius = '4px';
export const ComponentAlertSuccessBorder = '#3c7b29';
export const ComponentAlertSuccessLinkColor = '#005ba8';
export const ComponentAlertCautionBg = '#ffffff';
export const ComponentAlertCautionRadius = '4px';
export const ComponentAlertCautionBorder = '#ebb000';
export const ComponentAlertCautionLinkColor = '#005ba8';
export const ComponentAvatarFontSizeLg = '22px';
export const ComponentAvatarFontSizeMd = '20px';
export const ComponentAvatarFontSizeSm = '16px';
export const ComponentAvatarFontSizeXs = '12px';
export const ComponentAvatarFontColorBlack = '#000000';
export const ComponentAvatarFontColorBlue = '#005ba8';
export const ComponentAvatarBorderRadius = '12px';
export const ComponentAvatarBorderColor = '#005ba8';
export const ComponentAvatarBackgroundWhite = '#ffffff';
export const ComponentAvatarBackgroundGray = '#e3e3e3';
export const ComponentAvatarBackgroundHover = '#ebf6ff';
export const ComponentAvatarFocusBorder = '#005ba8';
export const ComponentAvatarShadowBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentBadgeFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentBadgeFontWeight = '400';
export const ComponentBadgeFontLineHeight = '115%';
export const ComponentBadgeFontSize = '14px';
export const ComponentBadgeBorderRadius = '12px';
export const ComponentBadgeHeight = '24px';
export const ComponentBadgePadding = '4px 10px';
export const ComponentBadgeVariantWhiteColor = '#000000';
export const ComponentBadgeVariantWhiteBg = '#ffffff';
export const ComponentBadgeVariantDarkColor = '#ffffff';
export const ComponentBadgeVariantDarkBg = '#4a4a4a';
export const ComponentBadgeVariantLightColor = '#000000';
export const ComponentBadgeVariantLightBg = '#e3e3e3';
export const ComponentBadgeVariantTransparentColor = '#ffffff';
export const ComponentBadgeVariantTransparentBorderColor = '#b2b2b2';
export const ComponentBadgeVariantTransparentBg = 'transparent';
export const ComponentBadgeVariantTransparentDarkColor = '#ffffff';
export const ComponentBadgeVariantTransparentDarkBorderColor = '#ffffff';
export const ComponentBadgeVariantInfoColor = '#000000';
export const ComponentBadgeVariantInfoBg = '#cce8ff';
export const ComponentBadgeVariantErrorColor = '#000000';
export const ComponentBadgeVariantErrorBg = '#ffd6cf';
export const ComponentBadgeVariantSuccessColor = '#000000';
export const ComponentBadgeVariantSuccessBg = '#c9eabf';
export const ComponentBadgeVariantCautionColor = '#000000';
export const ComponentBadgeVariantCautionBg = '#fff0c2';
export const ComponentBadgeIconSize = '14px';
export const ComponentBadgeIconDefaultColor = '#959595';
export const ComponentBadgeIconDarkColor = '#ffffff';
export const ComponentBadgeIconInfoColor = '#57a0db';
export const ComponentBadgeIconErrorColor = '#f06f61';
export const ComponentBadgeIconSuccessColor = '#53ac39';
export const ComponentBadgeIconCautionColor = '#ffc20e';
export const ComponentBadgeIconTransparentColor = '#959595';
export const ComponentBtnColor = '#ffffff';
export const ComponentBtnBg = '#005ba8';
export const ComponentBtnFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentBtnFontWeight = '600';
export const ComponentBtnFontSize = '16px';
export const ComponentBtnFontLineHeight = '100%';
export const ComponentBtnSizeLargePadding = '14px 16px 14px 16px';
export const ComponentBtnSizeLargeFontSize = '20px';
export const ComponentBtnSizeLargeLineHeight = '100%';
export const ComponentBtnSizeLargeBorderRadius = '4px';
export const ComponentBtnSizeLargeHeight = '48px';
export const ComponentBtnSizeAuxPadding = '6px 4px 6px 4px';
export const ComponentBtnSizeAuxFontSize = '12px';
export const ComponentBtnSizeAuxFontWeight = '400';
export const ComponentBtnSizeAuxLineHeight = '100%';
export const ComponentBtnSizeAuxBorderRadius = '4px';
export const ComponentBtnSizeAuxHeight = '24px';
export const ComponentBtnSizeSmallPadding = '8px';
export const ComponentBtnSizeSmallFontSize = '14px';
export const ComponentBtnSizeSmallLineHeight = '115%';
export const ComponentBtnSizeSmallBorderRadius = '4px';
export const ComponentBtnSizeSmallHeight = '32px';
export const ComponentBtnSizeDefaultPadding = '12px';
export const ComponentBtnSizeDefaultFontSize = '16px';
export const ComponentBtnSizeDefaultLineHeight = '100%';
export const ComponentBtnSizeDefaultBorderRadius = '4px';
export const ComponentBtnSizeDefaultHeight = '40px';
export const ComponentBtnDisabledBg = '#e3e3e3';
export const ComponentBtnDisabledBorder = '#e3e3e3';
export const ComponentBtnDisabledColor = '#959595';
export const ComponentBtnDisabledCursor = 'not-allowed';
export const ComponentBtnPrimaryColor = '#ffffff';
export const ComponentBtnPrimaryBg = '#005ba8';
export const ComponentBtnPrimaryBorder = 'rgba(0, 0, 0, 0)';
export const ComponentBtnPrimaryHoverColor = '#ffffff';
export const ComponentBtnPrimaryHoverBg = '#2372b8';
export const ComponentBtnPrimaryHoverBorder = '#ffffff';
export const ComponentBtnPrimaryActiveColor = '#ffffff';
export const ComponentBtnPrimaryActiveBg = '#2372b8';
export const ComponentBtnPrimaryActiveBorder = '#ffffff';
export const ComponentBtnPrimaryFocusColor = '#ffffff';
export const ComponentBtnPrimaryFocusBg = '#005ba8';
export const ComponentBtnPrimaryFocusBorder = '#005ba8';
export const ComponentBtnPrimaryFocusBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentBtnSecondaryColor = '#005ba8';
export const ComponentBtnSecondaryBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnSecondaryBorder = '#005ba8';
export const ComponentBtnSecondaryHoverColor = '#005ba8';
export const ComponentBtnSecondaryHoverBg = '#ebf6ff';
export const ComponentBtnSecondaryHoverBorder = '#005ba8';
export const ComponentBtnSecondaryActiveColor = '#005ba8';
export const ComponentBtnSecondaryActiveBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnSecondaryActiveBorder = '#005ba8';
export const ComponentBtnSecondaryActiveBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentBtnSecondaryFocusColor = '#005ba8';
export const ComponentBtnSecondaryFocusBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnSecondaryFocusBorder = '#005ba8';
export const ComponentBtnSecondaryFocusBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentBtnSecondaryDisabledColor = '#959595';
export const ComponentBtnSecondaryDisabledBackground = 'rgba(0, 0, 0, 0)';
export const ComponentBtnSecondaryDisabledBorder = '#b2b2b2';
export const ComponentBtnTextColor = '#005ba8';
export const ComponentBtnTextBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnTextBorder = 'transparent';
export const ComponentBtnTextHoverColor = '#005ba8';
export const ComponentBtnTextHoverBg = '#ebf6ff';
export const ComponentBtnTextHoverBorder = 'transparent';
export const ComponentBtnTextActiveColor = '#005ba8';
export const ComponentBtnTextActiveBg = '#ebf6ff';
export const ComponentBtnTextActiveBorder = 'transparent';
export const ComponentBtnTextFocusColor = '#005ba8';
export const ComponentBtnTextFocusBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnTextFocusBorder = 'rgba(0, 0, 0, 0)';
export const ComponentBtnTextFocusBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentBtnAuxColor = '#005ba8';
export const ComponentBtnAuxBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnAuxBorder = 'transparent';
export const ComponentBtnAuxHoverColor = '#005ba8';
export const ComponentBtnAuxHoverBg = '#ebf6ff';
export const ComponentBtnAuxHoverBorder = 'transparent';
export const ComponentBtnAuxActiveColor = '#005ba8';
export const ComponentBtnAuxActiveBg = '#ebf6ff';
export const ComponentBtnAuxActiveBorder = 'transparent';
export const ComponentBtnAuxFocusColor = '#005ba8';
export const ComponentBtnAuxFocusBg = 'rgba(0, 0, 0, 0)';
export const ComponentBtnAuxFocusBorder = 'rgba(0, 0, 0, 0)';
export const ComponentBtnAuxFocusBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentIconBtnSizeLargePadding = '14px';
export const ComponentIconBtnSizeLargeFontSize = '20px';
export const ComponentIconBtnSizeLargeLineHeight = '100%';
export const ComponentIconBtnSizeLargeBorderRadius = '4px';
export const ComponentIconBtnSizeLargeHeight = '48px';
export const ComponentIconBtnSizeLargeWidth = '48px';
export const ComponentIconBtnSizeSmallPadding = '8px';
export const ComponentIconBtnSizeSmallFontSize = '14px';
export const ComponentIconBtnSizeSmallLineHeight = '115%';
export const ComponentIconBtnSizeSmallBorderRadius = '4px';
export const ComponentIconBtnSizeSmallHeight = '32px';
export const ComponentIconBtnSizeSmallWidth = '32px';
export const ComponentIconBtnSizeDefaultPadding = '12px';
export const ComponentIconBtnSizeDefaultFontSize = '16px';
export const ComponentIconBtnSizeDefaultLineHeight = '100%';
export const ComponentIconBtnSizeDefaultBorderRadius = '4px';
export const ComponentIconBtnSizeDefaultHeight = '40px';
export const ComponentIconBtnSizeDefaultWidth = '40px';
export const ComponentCardBg = '#ffffff';
export const ComponentCardBorderColor = '#b2b2b2';
export const ComponentCardBorderRadius = '4px';
export const ComponentCardPadding = '16px';
export const ComponentCardBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentCardHeaderFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentCardHeaderFontColor = '#000000';
export const ComponentCardHeaderFontWeight = '600';
export const ComponentCardHeaderFontSize = '16px';
export const ComponentCardHeaderFontLineHeight = '130%';
export const ComponentCardHeaderPaddingBottom = '4px';
export const ComponentCardContentBg = '#ffffff';
export const ComponentCardContentFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentCardContentFontColor = '#6d6d6d';
export const ComponentCardContentFontWeight = '400';
export const ComponentCardContentFontSize = '14px';
export const ComponentCardContentFontLineHeight = '130%';
export const ComponentCheckboxFormLabelColor = '#6d6d6d';
export const ComponentCheckboxLabelColor = '#000000';
export const ComponentCheckboxLabelFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentCheckboxLabelFontSize = '16px';
export const ComponentCheckboxLabelMargin = '8px';
export const ComponentCheckboxDefaultBg = '#ffffff';
export const ComponentCheckboxDefaultColor = 'transparent';
export const ComponentCheckboxDefaultBorder = '#959595';
export const ComponentCheckboxDefaultHoverBg = '#ebf6ff';
export const ComponentCheckboxCheckedBg = '#003468';
export const ComponentCheckboxCheckedColor = '#ffffff';
export const ComponentCheckboxDisabledBg = '#e3e3e3';
export const ComponentCheckboxDisabledColor = '#959595';
export const ComponentCheckboxDisabledBorder = '#b2b2b2';
export const ComponentCheckboxFocusColor = '#005ba8';
export const ComponentCheckboxBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentCheckboxErrorColor = '#d41e27';
export const ComponentChipFontSize = '14px';
export const ComponentChipActiveBg = '#003468';
export const ComponentChipActiveBorder = '#003468';
export const ComponentChipActiveColor = '#ffffff';
export const ComponentChipFilterColor = '#000000';
export const ComponentChipFilterBg = '#ffffff';
export const ComponentChipFilterBorder = '#b2b2b2';
export const ComponentChipFilterIconColor = '#5a5a5a';
export const ComponentChipToggleColor = '#000000';
export const ComponentChipToggleBg = '#ffffff';
export const ComponentChipToggleBorder = '#005ba8';
export const ComponentChipLinkColor = '#005ba8';
export const ComponentChipLinkBg = '#ffffff';
export const ComponentChipLinkBorder = '#005ba8';
export const ComponentChipHoverBg = '#ebf6ff';
export const ComponentChipDisabledBg = '#e3e3e3';
export const ComponentChipDisabledBorder = '#b2b2b2';
export const ComponentChipDisabledColor = '#959595';
export const ComponentChipDisabledCursor = 'not-allowed';
export const ComponentDatePickerFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentDatePickerBorderColor = '#959595';
export const ComponentDatePickerPaperHeaderDayColor = '#b2b2b2';
export const ComponentDatePickerPaperBoxShadowColor = '#b2b2b2';
export const ComponentDatePickerPaperColor = '#000000';
export const ComponentDatePickerPaperFocusBg = '#ebf6ff';
export const ComponentDatePickerPaperHoverBg = '#ebf6ff';
export const ComponentDatePickerPaperSelectedColor = '#ffffff';
export const ComponentDatePickerPaperSelectedBg = '#003468';
export const ComponentDatePickerTextFieldIconDateColor = '#5a5a5a';
export const ComponentDatePickerTextFieldIconDatePrimaryColor = '#005ba8';
export const ComponentDatePickerTextFieldIconDateErrorColor = '#d41e27';
export const ComponentDatePickerTextFieldIconDateDisabled = '#959595';
export const ComponentDatePickerDayOutsideColor = '#959595';
export const ComponentDatePickerDayColor = '#000000';
export const ComponentDatePickerDayFocusBg = '#ebf6ff';
export const ComponentDatePickerDayHoverBg = '#ebf6ff';
export const ComponentDatePickerDaySelectedColor = '#ffffff';
export const ComponentDatePickerDaySelectedBg = '#003468';
export const ComponentDatePickerCalendarHeaderColor = '#005ba8';
export const ComponentDatePickerDisabledBg = '#ffffff';
export const ComponentDatePickerDisabledColor = '#959595';
export const ComponentDatePickerDisabledCursor = 'not-allowed';
export const ComponentDateRangePickerInputContainerBorderRadius = '4px';
export const ComponentDateRangePickerInputContainerBorderColor = '#959595';
export const ComponentDateRangePickerInputContainerBackgroundColor = '#ffffff';
export const ComponentDateRangePickerDisabledBorderColor = '#b2b2b2';
export const ComponentDateRangePickerDisabledBackgroundColor = '#e3e3e3';
export const ComponentDateRangePickerDisabledColor = '#959595';
export const ComponentDropdownItemBg = 'transparent';
export const ComponentDropdownItemFontSize = '16px';
export const ComponentDropdownItemFontWeight = '500';
export const ComponentDropdownItemColor = '#005ba8';
export const ComponentDropdownItemLineHeight = '125%';
export const ComponentDropdownItemPadding = '8px 16px';
export const ComponentDropdownItemHoverBg = '#ebf6ff';
export const ComponentDropdownItemFocusBg = '#ebf6ff';
export const ComponentDropdownItemActiveBg = '#ebf6ff';
export const ComponentDropdownItemDisabledBg = '#e3e3e3';
export const ComponentDropdownItemDisabledBorder = '#b2b2b2';
export const ComponentDropdownItemDisabledColor = '#959595';
export const ComponentDropdownItemDisabledCursor = 'not-allowed';
export const ComponentDropdownBoxShadowColor = 'rgba(22, 23, 26, .1)';
export const ComponentDropdownDividerBorderColor = '#959595';
export const ComponentFlagFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentFlagPadding = '4px 10px';
export const ComponentFlagVariantWhiteColor = '#000000';
export const ComponentFlagVariantWhiteBg = '#ffffff';
export const ComponentFlagVariantDarkColor = '#ffffff';
export const ComponentFlagVariantDarkBg = '#4a4a4a';
export const ComponentFlagVariantLightColor = '#000000';
export const ComponentFlagVariantLightBg = '#e3e3e3';
export const ComponentFlagVariantTransparentColor = '#ffffff';
export const ComponentFlagVariantTransparentBorderColor = '#b2b2b2';
export const ComponentFlagVariantTransparentBg = 'transparent';
export const ComponentFlagVariantTransparentDarkColor = '#ffffff';
export const ComponentFlagVariantTransparentDarkBorderColor = '#ffffff';
export const ComponentFlagVariantInfoColor = '#000000';
export const ComponentFlagVariantInfoBg = '#cce8ff';
export const ComponentFlagVariantErrorColor = '#000000';
export const ComponentFlagVariantErrorBg = '#ffd6cf';
export const ComponentFlagVariantSuccessColor = '#000000';
export const ComponentFlagVariantSuccessBg = '#c9eabf';
export const ComponentFlagVariantCautionColor = '#000000';
export const ComponentFlagVariantCautionBg = '#fff0c2';
export const ComponentFlagIconSize = '12px';
export const ComponentFlagIconDefaultColor = '#959595';
export const ComponentFlagIconDarkColor = '#ffffff';
export const ComponentFlagIconInfoColor = '#57a0db';
export const ComponentFlagIconErrorColor = '#f06f61';
export const ComponentFlagIconSuccessColor = '#53ac39';
export const ComponentFlagIconCautionColor = '#ffc20e';
export const ComponentFlagIconTransparentColor = '#959595';
export const ComponentFabFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentFabPrimaryColor = '#ffffff';
export const ComponentFabPrimaryBg = '#005ba8';
export const ComponentFabPrimaryHoverColor = '#ffffff';
export const ComponentFabPrimaryHoverBg = '#2372b8';
export const ComponentFabSecondaryBg = '#ffffff';
export const ComponentFabSecondaryColor = '#005ba8';
export const ComponentFabSecondaryHoverColor = '#005ba8';
export const ComponentFabSecondaryHoverBg = '#ebf6ff';
export const ComponentFabDisabledBg = '#e3e3e3';
export const ComponentFabDisabledColor = '#959595';
export const ComponentLinkFontSizeLg = '18px';
export const ComponentLinkFontSizeMd = '16px';
export const ComponentLinkFontSizeSm = '14px';
export const ComponentLinkFontSizeXs = '12px';
export const ComponentLinkFontSizeXxs = '10px';
export const ComponentLinkFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentLinkColor = '#005ba8';
export const ComponentLinkHover = '#318ad3';
export const ComponentLinkVisited = '#a9216a';
export const ComponentListBoxItemBg = 'transparent';
export const ComponentListBoxItemFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentListBoxItemFontSizeSmall = '14px';
export const ComponentListBoxItemFontSizeMedium = '16px';
export const ComponentListBoxItemFontSizeLarge = '20px';
export const ComponentListBoxItemFontWeight = '400';
export const ComponentListBoxItemColor = '#000000';
export const ComponentListBoxItemLineHeightSmall = '115%';
export const ComponentListBoxItemLineHeightMedium = '125%';
export const ComponentListBoxItemLineHeightLarge = '120%';
export const ComponentListBoxItemPadding = '8px 16px';
export const ComponentListBoxItemHoverBg = '#ebf6ff';
export const ComponentListBoxItemFocusBg = '#ebf6ff';
export const ComponentListBoxItemActiveBg = '#ebf6ff';
export const ComponentListBoxItemDisabledBg = '#e3e3e3';
export const ComponentListBoxItemDisabledBorder = '#b2b2b2';
export const ComponentListBoxItemDisabledColor = '#959595';
export const ComponentListBoxItemDisabledCursor = 'not-allowed';
export const ComponentListBoxItemSelectedIconColor = '#003468';
export const ComponentListBoxBoxShadowColor = 'rgba(22, 23, 26, .1)';
export const ComponentListBoxDividerBorderColor = '#959595';
export const ComponentListBoxBackgroundColor = '#ffffff';
export const ComponentListBoxGroupNameColor = '#6d6d6d';
export const ComponentListBoxGroupNameFontSizeSmall = '12px';
export const ComponentListBoxGroupNameFontSizeMedium = '14px';
export const ComponentListBoxGroupNameFontSizeLarge = '16px';
export const ComponentListBoxGroupNameLineHeight = '120%';
export const ComponentListBoxGroupNameFontWeight = '600';
export const ComponentListBoxGroupNameFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentListItemsFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentListItemsFontSize = '14px';
export const ComponentListItemsFontColor = '#000000';
export const ComponentListItemBg = '#ffffff';
export const ComponentListItemBorderColor = '#b2b2b2';
export const ComponentListItemBorderRadius = '4px';
export const ComponentListItemHoverColor = '#ebf6ff';
export const ComponentListItemSelectedColor = '#003468';
export const ComponentLocalNavigationItemBg = 'transparent';
export const ComponentLocalNavigationItemFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentLocalNavigationItemFontSize = '16px';
export const ComponentLocalNavigationItemFontWeight = '500';
export const ComponentLocalNavigationItemColor = '#005ba8';
export const ComponentLocalNavigationItemLineHeight = '125%';
export const ComponentLocalNavigationItemPadding = '8px 16px';
export const ComponentLocalNavigationItemHoverBg = '#ebf6ff';
export const ComponentLocalNavigationItemHoverColor = '#005ba8';
export const ComponentLocalNavigationItemFocusBg = '#ebf6ff';
export const ComponentLocalNavigationItemActiveBg = '#ebf6ff';
export const ComponentLocalNavigationItemDisabledBg = '#e3e3e3';
export const ComponentLocalNavigationItemDisabledBorder = '#b2b2b2';
export const ComponentLocalNavigationItemDisabledColor = '#959595';
export const ComponentLocalNavigationItemDisabledCursor = 'not-allowed';
export const ComponentLocalNavigationItemSelectedBorder = '#003468';
export const ComponentLocalNavigationItemSelectedColor = '#000000';
export const ComponentLocalNavigationBoxShadowColor = 'rgba(22, 23, 26, .1)';
export const ComponentLocalNavigationBackgroundColor = '#ffffff';
export const ComponentLocalNavigationGroupNameColor = '#6d6d6d';
export const ComponentLocalNavigationGroupNameFontSize = '14px';
export const ComponentLocalNavigationGroupNameLineHeight = '120%';
export const ComponentLocalNavigationGroupNameFontWeight = '600';
export const ComponentLocalNavigationGroupNameFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentMenuDisabledColor = '#959595';
export const ComponentMenuHoverColor = '#ebf6ff';
export const ComponentMenuFontColor = '#005ba8';
export const ComponentMenuBoxShadowColor = '#b2b2b2';
export const ComponentMenuBorderColor = '#959595';
export const ComponentModalHeaderPadding = '16px 16px 0 16px';
export const ComponentModalBodyPadding = '16px';
export const ComponentModalBodyColor = '#000000';
export const ComponentModalBodyFontSize = '16px';
export const ComponentModalBodyFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentModalBodyFontWeight = '400';
export const ComponentModalBackdropColor = '#4a4a4a';
export const ComponentModalBackdropLargeOnXsColor = '#ffffff';
export const ComponentModalFooterPadding = '0 16px 16px 16px';
export const ComponentModalFooterBackgroundColor = '#ffffff';
export const ComponentModalFooterLargeOnXsBackgroundColor = 'rgba(244, 244, 244, 0.96)';
export const ComponentModalBorderRadius = '4px';
export const ComponentModalBorderColor = '#959595';
export const ComponentModalBoxShadowColor = '#4a4a4a';
export const ComponentModalCloseButtonColor = '#5a5a5a';
export const ComponentModalCloseButtonRadius = '4px';
export const ComponentModalTitleColor = '#000000';
export const ComponentModalTitleSmallLineHeight = '120%';
export const ComponentModalTitleSmallFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentModalTitleSmallFontWeight = '500';
export const ComponentModalTitleSmallFontSize = '16px';
export const ComponentModalTitleLargeLineHeight = '120%';
export const ComponentModalTitleLargeFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentModalTitleLargeFontWeight = '600';
export const ComponentModalTitleLargeFontSize = '20px';
export const ComponentModalTitleLargeOnXsLineHeight = '120%';
export const ComponentModalTitleLargeOnXsFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentModalTitleLargeOnXsFontWeight = '600';
export const ComponentModalTitleLargeOnXsFontSize = '20px';
export const ComponentNumberStepperBg = '#ffffff';
export const ComponentNumberStepperFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentNumberStepperBorder = '#959595';
export const ComponentNumberStepperDisabledBg = '#e3e3e3';
export const ComponentNumberStepperDisabledBorderColor = '#b2b2b2';
export const ComponentNumberStepperDisabledColor = '#959595';
export const ComponentNumberStepperDisabledCursor = 'not-allowed';
export const ComponentNumberStepperIcon = '#005ba8';
export const ComponentNumberStepperHover = '#ebf6ff';
export const ComponentNumberStepperFocusBorder = '#005ba8';
export const ComponentNumberStepperBoxShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentPaginationColor = '#005ba8';
export const ComponentPaginationHoverBackgroundColor = '#ebf6ff';
export const ComponentPaginationFontSize = '16px';
export const ComponentPaginationSelectedBg = 'transparent';
export const ComponentPaginationSelectedColor = '#003468';
export const ComponentPaginationDisabledColor = '#959595';
export const ComponentPopoverBg = '#ffffff';
export const ComponentPopoverBorderColor = '#b2b2b2';
export const ComponentPopoverColor = '#333333';
export const ComponentPopoverFontWeight = '400';
export const ComponentPopoverFontSize = '16px';
export const ComponentPopoverFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentPopoverBoxShadow = '#b2b2b2';
export const ComponentPopoverHeader = '#000000';
export const ComponentPopoverCloseBtn = '#5a5a5a';
export const ComponentRadioButtonLabelColor = '#000000';
export const ComponentRadioButtonLabelFont = "'Roboto Flex', Roboto, sans-serif";
export const ComponentRadioButtonLabelFontSize = '16px';
export const ComponentRadioButtonLabelFontWeight = '400';
export const ComponentRadioButtonLabelLineHeight = '125%';
export const ComponentRadioButtonLabelMargin = '4px';
export const ComponentRadioButtonLabelStrongLabelFontWeight = '700';
export const ComponentRadioButtonBg = '#ffffff';
export const ComponentRadioButtonBorderColor = '#959595';
export const ComponentRadioButtonBorderFocusColor = '#005ba8';
export const ComponentRadioButtonBorderFocusShadow = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const ComponentRadioButtonDisabledBorderColor = '#b2b2b2';
export const ComponentRadioButtonDisabledBg = '#e3e3e3';
export const ComponentRadioButtonDisabledColor = '#b2b2b2';
export const ComponentRadioButtonHoverColor = '#ebf6ff';
export const ComponentRadioButtonCheckedBgImageDefaultChecked = '#959595';
export const ComponentRadioButtonCheckedBgImageColor = '#003468';
export const ComponentRadioButtonCheckedBorderDefaultChecked = '#959595';
export const ComponentRadioButtonCheckedBorderColor = '#003468';
export const ComponentRadioButtonCheckedBoxShadowDefaultChecked = '#959595';
export const ComponentRadioButtonCheckedBoxShadowColor = '#003468';
export const ComponentRibbonFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentRibbonVariantWhiteColor = '#000000';
export const ComponentRibbonVariantWhiteBg = '#ffffff';
export const ComponentRibbonVariantDarkColor = '#ffffff';
export const ComponentRibbonVariantDarkBg = '#4a4a4a';
export const ComponentRibbonVariantLightColor = '#000000';
export const ComponentRibbonVariantLightBg = '#e3e3e3';
export const ComponentRibbonVariantTransparentColor = '#ffffff';
export const ComponentRibbonVariantTransparentBorderColor = '#b2b2b2';
export const ComponentRibbonVariantTransparentBg = 'transparent';
export const ComponentRibbonVariantTransparentDarkColor = '#ffffff';
export const ComponentRibbonVariantTransparentDarkBorderColor = '#ffffff';
export const ComponentRibbonVariantInfoColor = '#000000';
export const ComponentRibbonVariantInfoBg = '#cce8ff';
export const ComponentRibbonVariantErrorColor = '#000000';
export const ComponentRibbonVariantErrorBg = '#ffd6cf';
export const ComponentRibbonVariantSuccessColor = '#000000';
export const ComponentRibbonVariantSuccessBg = '#c9eabf';
export const ComponentRibbonVariantCautionColor = '#000000';
export const ComponentRibbonVariantCautionBg = '#fff0c2';
export const ComponentSearchInputListBoxBorderColor = '#959595';
export const ComponentSearchInputGroupHeaderColor = '#6d6d6d';
export const ComponentSearchInputGroupOptionColor = '#000000';
export const ComponentSearchInputGroupOptionFocusColor = '#ebf6ff';
export const ComponentSelectInputChevronIconErrorColor = '#d41e27';
export const ComponentSelectInputChevronIconActiveColor = '#005ba8';
export const ComponentSelectInputDisabledColor = '#b2b2b2';
export const ComponentSelectInputReadOnlyColor = '#000000';
export const ComponentSimpleTableFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentSimpleTableFontWeight = '400';
export const ComponentSimpleTableHeaderBgWhiteColor = '#6d6d6d';
export const ComponentSimpleTableHeaderBgWhiteBg = '#ffffff';
export const ComponentSimpleTableHeaderBgWhiteBorderColor = '#b2b2b2';
export const ComponentSimpleTableHeaderBgLightColor = '#6d6d6d';
export const ComponentSimpleTableHeaderBgLightBg = '#f4f4f4';
export const ComponentSimpleTableHeaderBgLightBorderColor = '#b2b2b2';
export const ComponentSimpleTableHeaderBgDarkColor = '#ffffff';
export const ComponentSimpleTableHeaderBgDarkBg = '#4a4a4a';
export const ComponentSimpleTableHeaderBgDarkBorderColor = '#000000';
export const ComponentSimpleTableHeaderSizeLarge = '14px';
export const ComponentSimpleTableHeaderSizeSmall = '12px';
export const ComponentSimpleTableBodyBorderColor = '#b2b2b2';
export const ComponentSimpleTableBodyColor = '#000000';
export const ComponentSimpleTableBodySizeLarge = '16px';
export const ComponentSimpleTableBodySizeSmall = '14px';
export const ComponentSimpleTableBodyHover = '#ebf6ff';
export const ComponentSimpleTableBorderColor = '#b2b2b2';
export const ComponentSimpleTableBg = '#ffffff';
export const ComponentSimpleTableRadius = 'none';
export const ComponentSimpleTableBoxShadow = 'none';
export const ComponentSimpleTableStripedBg = '#f4f4f4';
export const ComponentSimpleTableStripedHoverBg = '#b2b2b2';
export const ComponentSlideOutRootBoxShadow = '#4a4a4a';
export const ComponentSlideOutBackdropColor = '#4a4a4a';
export const ComponentSlideOutBackdropLargeOnXsColor = '#ffffff';
export const ComponentSlideOutDialogBodyFontSize = '16px';
export const ComponentSlideOutDialogBodyFontColor = '#000000';
export const ComponentSlideOutDialogBodyFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentDrawerTitleBorderColor = '#b2b2b2';
export const ComponentDrawerTitleColor = '#000000';
export const ComponentDrawerTitleDefaultLineHeight = '120%';
export const ComponentDrawerTitleDefaultFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentDrawerTitleDefaultFontWeight = '600';
export const ComponentDrawerTitleDefaultFontSize = '20px';
export const ComponentSnackbarFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentSnackbarColorShadow = '#b2b2b2';
export const ComponentSnackbarColorBackground = '#4a4a4a';
export const ComponentSnackbarColorHoverBackground = '#5a5a5a';
export const ComponentSnackbarColorIconInfo = '#57a0db';
export const ComponentSnackbarColorIconSuccess = '#53ac39';
export const ComponentSnackbarColorIconWarning = '#ffc20e';
export const ComponentSnackbarColorIconError = '#f06f61';
export const ComponentSnackbarColorButton = '#ffffff';
export const ComponentSnackbarColorMessage = '#ffffff';
export const ComponentSpinnerSpinnerCircularProgressColor = '#2372b8';
export const ComponentSpinnerTextColor = '#5a5a5a';
export const ComponentSpinnerOverlayColor = 'rgba(74, 74, 74, 0.8)';
export const ComponentSpinnerLightColor = '#ffffff';
export const ComponentSplitButtonDisabledBg = '#e3e3e3';
export const ComponentSplitButtonDividerBorder = '#b2b2b2';
export const ComponentStatusIndicatorDotColor = '#d41e27';
export const ComponentStatusIndicatorStandardColor = '#ffffff';
export const ComponentStatusIndicatorStandardBg = '#d41e27';
export const ComponentStatusIndicatorFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentStepperBorder = '#b2b2b2';
export const ComponentStepperColor = '#000000';
export const ComponentStepperFontWeight = '400';
export const ComponentStepperFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentStepperFontSize = '16px';
export const ComponentStepperFocusBorder = '#005ba8';
export const ComponentStepperShadowColor = '#cce8ff';
export const ComponentStepperActiveColor = '#000000';
export const ComponentStepperActiveBorder = '#003468';
export const ComponentStepperActiveFontWeight = '600';
export const ComponentStepperCompletedColor = '#3c7b29';
export const ComponentStepperCompletedBorder = '#3c7b29';
export const ComponentStepperErrorColor = '#d41e27';
export const ComponentStepperErrorBorder = '#d41e27';
export const ComponentSubmitButtonDotDangerDefault = '#ffffff';
export const ComponentSubmitButtonDotDangerHover = '#ffffff';
export const ComponentSubmitButtonDotPrimaryDefault = '#ffffff';
export const ComponentSubmitButtonDotPrimaryHover = '#ffffff';
export const ComponentSubmitButtonDotSecondaryDefault = '#005ba8';
export const ComponentSubmitButtonDotSecondaryHover = '#ffffff';
export const ComponentSubmitButtonDotLinkDefault = '#005ba8';
export const ComponentSubmitButtonDotLinkHover = '#005ba8';
export const ComponentSubmitButtonDotDefaultDefault = '#5a5a5a';
export const ComponentSubmitButtonDotDefaultHover = '#5a5a5a';
export const ComponentTableCellPaddingLgHorizontal = '14px';
export const ComponentTableCellPaddingLgVertical = '16px';
export const ComponentTableCellPaddingSmHorizontal = '10px';
export const ComponentTableCellPaddingSmVertical = '16px';
export const ComponentTableCellFontSm = '14px';
export const ComponentTableCellFontLg = '16px';
export const ComponentTableHeaderBackgroundColor = '#ffffff';
export const ComponentTableHeaderBackgroundColorLight = '#f4f4f4';
export const ComponentTableHeaderBackgroundColorDark = '#4a4a4a';
export const ComponentTableHeaderColor = '#6d6d6d';
export const ComponentTableHeaderColorDark = '#ffffff';
export const ComponentTableHeaderFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentTableHeaderFontWeight = '400';
export const ComponentTableHeaderLineHeight = '100%';
export const ComponentTableHeaderFontSizeSm = '12px';
export const ComponentTableHeaderFontSizeLg = '14px';
export const ComponentTableHeaderPaddingLgHorizontal = '12px';
export const ComponentTableHeaderPaddingLgVertical = '16px';
export const ComponentTableHeaderPaddingSmHorizontal = '8px';
export const ComponentTableHeaderPaddingSmVertical = '16px';
export const ComponentTableBorderColor = '#b2b2b2';
export const ComponentTableBorderRadius = '0';
export const ComponentTableBorderBlackColor = '#000000';
export const ComponentTableColor = '#000000';
export const ComponentTableColorDark = '#ffffff';
export const ComponentTableFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentTableFontSize = '16px';
export const ComponentTableFontWeight = '400';
export const ComponentTableBackgroundColor = '#ffffff';
export const ComponentTableRowHoverBackground = '#ebf6ff';
export const ComponentTableRowBackground = '#ffffff';
export const ComponentTableRowExpandedPaddingTop = '16px';
export const ComponentTableRowExpandedPaddingRight = '16px';
export const ComponentTableRowExpandedPaddingBottom = '16px';
export const ComponentTableRowExpandedPaddingLeft = '16px';
export const ComponentTablePlaceholderColor = '#b2b2b2';
export const ComponentTablePaginationItemActiveBackground = '#005ba8';
export const ComponentTablePaginationItemActiveColor = '#ffffff';
export const ComponentTablePaginationItemActiveFontWeight = '500';
export const ComponentTablePaginationItemColor = '#005ba8';
export const ComponentTablePaginationItemBackground = '#ffffff';
export const ComponentTablePaginationArrowDisabled = '#b2b2b2';
export const ComponentTablePaginationArrowHover = '#005ba8';
export const ComponentTablePaginationJump = '#005ba8';
export const ComponentTableCheckedBackground = '#003468';
export const ComponentTableCheckedBorder = '#003468';
export const ComponentTableSortIconColorSorted = '#6d6d6d';
export const ComponentTableSortIconColorSortedDark = '#ffffff';
export const ComponentTableSortIconColorNoSort = '#b2b2b2';
export const ComponentTabsBg = 'transparent';
export const ComponentTabsSelectedColor = '#000000';
export const ComponentTabsDisabledColor = '#959595';
export const ComponentTabsUnSelectedColor = '#005ba8';
export const ComponentTabsIndicatorColor = '#003468';
export const ComponentTabsFocusBorder = '#005ba8';
export const ComponentTabsHoverColor = '#ebf6ff';
export const ComponentTextInputAdornmentFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentTextInputAdornmentFontSize = '16px';
export const ComponentTextInputAdornmentFontWeight = '400';
export const ComponentTextInputAdornmentColor = '#6d6d6d';
export const ComponentTextInputAdornmentIconColor = '#959595';
export const ComponentTextInputAdornmentBg = '#ffffff';
export const ComponentTextInputAdornmentLineHeight = '100%';
export const ComponentTextInputClearIconHoverColor = '#005ba8';
export const ComponentTextInputClearIconFocusColor = '#005ba8';
export const ComponentTextInputClearIconActiveColor = '#005ba8';
export const ComponentTextInputFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const ComponentTextInputFontSize = '16px';
export const ComponentTextInputFontWeight = '400';
export const ComponentTextInputBg = '#ffffff';
export const ComponentTextInputBorderColor = '#959595';
export const ComponentTextInputBorderFocusColor = '#005ba8';
export const ComponentTextInputBorderFocusShadowColor = '#cce8ff';
export const ComponentTextInputBorderShadowColor = '#cce8ff';
export const ComponentTextInputBorderErrorColor = '#d41e27';
export const ComponentTextInputBorderErrorFocusColor = '#d41e27';
export const ComponentTextInputBorderSuccessColor = '#3c7b29';
export const ComponentTextInputBorderRadius = '4px';
export const ComponentTextInputLineHeight = '100%';
export const ComponentTextInputPlaceholderColor = '#b2b2b2';
export const ComponentTextInputLabelColor = '#6d6d6d';
export const ComponentTextInputLabelFontSizeSmall = '12px';
export const ComponentTextInputLabelFontSizeMedium = '14px';
export const ComponentTextInputLabelFontSizeLarge = '18px';
export const ComponentTextInputInputColor = '#000000';
export const ComponentTextInputInputSizeSmall = '32px';
export const ComponentTextInputInputSizeMedium = '40px';
export const ComponentTextInputInputSizeLarge = '48px';
export const ComponentTextInputInputFontSizeSmall = '14px';
export const ComponentTextInputInputFontSizeMedium = '16px';
export const ComponentTextInputInputFontSizeLarge = '20px';
export const ComponentTextInputAsteriskColor = '#d41e27';
export const ComponentTextInputErrorColor = '#d41e27';
export const ComponentTextInputWarningColor = '#ebb000}';
export const ComponentTextInputMessageFontSize = '14px';
export const ComponentTextInputMessageFontWeight = '400';
export const ComponentTextInputMessageFontColor = '#6d6d6d';
export const ComponentTextInputMessageLineHeight = '100%';
export const ComponentTextInputDisabledBorderColor = '#b2b2b2';
export const ComponentTextInputDisabledBgColor = '#e3e3e3';
export const ComponentTextInputDisabledColor = '#959595';
export const ComponentTextInputReadOnlyBorderColor = '#b2b2b2';
export const ComponentTextInputReadOnlyColor = '#959595';
export const ComponentTextInputReadOnlyBgColor = '#e3e3e3';
export const ComponentTimePickerButtonColor = '#005ba8';
export const ComponentTimePickerButtonHoverColor = '#ffffff';
export const ComponentTimePickerButtonHoverBg = '#005ba8';
export const ComponentTimePickerButtonHoverBorder = '#005ba8';
export const ComponentTimePickerButtonFocusColor = '#ffffff';
export const ComponentTimePickerButtonFocusBg = '#005ba8';
export const ComponentTimePickerButtonFocusBorder = '#005ba8';
export const ComponentTimePickerButtonActiveColor = '#ffffff';
export const ComponentTimePickerButtonActiveBg = '#005ba8';
export const ComponentTimePickerButtonActiveBorder = '#005ba8';
export const ComponentTimePickerButtonDisabledColor = '#6d6d6d';
export const ComponentTimePickerButtonDisabledCursor = 'not-allowed';
export const ComponentTimePickerClockIconColor = '#005ba8';
export const ComponentTimePickerClockIconDisabledColor = '#959595';
export const ComponentTimePickerClockIconErrorColor = '#d41e27';
export const ComponentTimePickerCloseIconColor = '#5a5a5a';
export const ComponentToastColorSuccess = '#3c7b29';
export const ComponentToastColorInfo = '#2372b8';
export const ComponentToastColorError = '#d41e27';
export const ComponentToastColorWarning = '#ebb000';
export const ComponentToastFontSize = '14px';
export const ComponentToastFontName = "'Roboto Flex', Roboto, sans-serif";
export const ComponentToastFontWeight = '400';
export const ComponentToggleGroupButtonBg = '#ffffff';
export const ComponentToggleGroupButtonColor = '#005ba8';
export const ComponentToggleGroupButtonBorder = '#b2b2b2';
export const ComponentToggleGroupButtonHoverBg = '#ebf6ff';
export const ComponentToggleGroupButtonHoverBorderLeft = '#b2b2b2';
export const ComponentToggleGroupButtonSelectedColor = '#000000';
export const ComponentToggleGroupButtonSelectedBg = '#ffffff';
export const ComponentToggleGroupButtonSelectedBorderLeft = '#b2b2b2';
export const ComponentToggleGroupButtonSelectedBorderBottom = '#003468';
export const ComponentSwitchFocusBorder = '#005ba8';
export const ComponentSwitchShadowColor = '#cce8ff';
export const ComponentSwitchThumbUncheckedColor = '#005ba8';
export const ComponentSwitchThumbCheckedColor = '#ffffff';
export const ComponentSwitchCheckMarkColor = '#005ba8';
export const ComponentSwitchLabelColor = '#6d6d6d';
export const ComponentSwitchTrackUncheckedBorder = '#005ba8';
export const ComponentSwitchTrackUncheckedBg = '#ffffff';
export const ComponentSwitchTrackRadius = '9999px';
export const ComponentSwitchTrackCheckedBackgroundColor = '#005ba8';
export const ComponentSwitchTrackCheckedBorderColor = '#005ba8';
export const ComponentSwitchDisabledColor = '#959595';
export const ComponentSwitchDisabledBg = '#e3e3e3';
export const ComponentSwitchDisabledCursor = 'not-allowed';
export const ComponentSwitchDisabledBorder = '#b2b2b2';
export const ComponentSwitchDisabledCheckMark = '#e3e3e3';
export const ComponentTooltipColor = '#ffffff';
export const ComponentTooltipBgColor = '#4a4a4a';
export const ComponentTooltipFontSizeLarge = '14px';
export const ComponentTooltipFontSizeSmall = '12px';
export const ComponentTooltipFontLineHeightLarge = '130%';
export const ComponentTooltipFontLineHeightSmall = '100%';
export const AliasTypeFontLoadingUrl = 'https://fonts.googleapis.com/css2?family=Roboto+Flex:opsz,slnt,wdth,wght,GRAD,XTRA,YOPQ,YTAS,YTDE,YTFI,YTLC,YTUC@8..144,-10..0,25..151,100..1000,-200..150,323..603,25..135,649..854,-305..-98,560..788,416..570,528..760&display=block';
export const AliasBaselineFontSize = '16px';
export const AliasBaselineFontFamily = "'Roboto Flex', Roboto, sans-serif";
export const BaseAnimationPulse = '2s ease-in-out 0.5s infinite normal none running pulse';
export const BaseColorTransparent = 'rgba(0, 0, 0, 0)';
export const BaseColorWhite = '#ffffff';
export const BaseColorBlack = '#000000';
export const BaseColorGray50 = '#f4f4f4';
export const BaseColorGray100 = '#e3e3e3';
export const BaseColorGray200 = '#cccccc';
export const BaseColorGray300 = '#b2b2b2';
export const BaseColorGray400 = '#959595';
export const BaseColorGray500 = '#828282';
export const BaseColorGray600 = '#6d6d6d';
export const BaseColorGray700 = '#5a5a5a';
export const BaseColorGray800 = '#4a4a4a';
export const BaseColorGray900 = '#333333';
export const BaseColorBlue50 = '#ebf6ff';
export const BaseColorBlue100 = '#cce8ff';
export const BaseColorBlue200 = '#a3d0f5';
export const BaseColorBlue300 = '#81b7e4';
export const BaseColorBlue400 = '#57a0db';
export const BaseColorBlue500 = '#318ad3';
export const BaseColorBlue600 = '#2372b8';
export const BaseColorBlue700 = '#005ba8';
export const BaseColorBlue800 = '#004986';
export const BaseColorBlue900 = '#003468';
export const BaseColorBlue950 = '#001b35';
export const BaseColorGreen50 = '#e9f6e5';
export const BaseColorGreen100 = '#c9eabf';
export const BaseColorGreen200 = '#9fda8e';
export const BaseColorGreen300 = '#6cc651';
export const BaseColorGreen400 = '#53ac39';
export const BaseColorGreen500 = '#479230';
export const BaseColorGreen600 = '#3c7b29';
export const BaseColorGreen700 = '#326622';
export const BaseColorGreen800 = '#28541a';
export const BaseColorGreen900 = '#203a17';
export const BaseColorAmber50 = '#fff0e6';
export const BaseColorAmber100 = '#ffdbc3';
export const BaseColorAmber200 = '#ffbd93';
export const BaseColorAmber300 = '#ff995a';
export const BaseColorAmber400 = '#f87216';
export const BaseColorAmber500 = '#d26217';
export const BaseColorAmber600 = '#b05417';
export const BaseColorAmber700 = '#924719';
export const BaseColorAmber800 = '#773a15';
export const BaseColorAmber900 = '#512912';
export const BaseColorRed50 = '#ffeae7';
export const BaseColorRed100 = '#ffd6cf';
export const BaseColorRed200 = '#ffb6aa';
export const BaseColorRed300 = '#f99384';
export const BaseColorRed400 = '#f06f61';
export const BaseColorRed500 = '#e44941';
export const BaseColorRed600 = '#d41e27';
export const BaseColorRed700 = '#b11d23';
export const BaseColorRed800 = '#94141b';
export const BaseColorRed900 = '#6f0000';
export const BaseColorGold50 = '#fff7e0';
export const BaseColorGold100 = '#fff0c2';
export const BaseColorGold200 = '#ffe699';
export const BaseColorGold300 = '#ffd966';
export const BaseColorGold400 = '#ffc20e';
export const BaseColorGold500 = '#ebb000';
export const BaseColorGold600 = '#b38600';
export const BaseColorGold700 = '#8f6b00';
export const BaseColorGold800 = '#664d00';
export const BaseColorGold900 = '#4d3900';
export const BaseColorFuchsia50 = '#fcf1f7';
export const BaseColorFuchsia100 = '#f8daeb';
export const BaseColorFuchsia200 = '#f2bddb';
export const BaseColorFuchsia300 = '#eb9ac8';
export const BaseColorFuchsia400 = '#e474b2';
export const BaseColorFuchsia500 = '#dc4a9b';
export const BaseColorFuchsia600 = '#ca2780';
export const BaseColorFuchsia700 = '#a9216a';
export const BaseColorFuchsia800 = '#8c1d58';
export const BaseColorFuchsia900 = '#62133d';
export const BaseOpacity0 = '0';
export const BaseOpacity10 = '0.1';
export const BaseOpacity25 = '0.25';
export const BaseOpacity50 = '0.5';
export const BaseOpacity80 = '0.8';
export const BaseOpacity90 = '0.9';
export const BaseOpacity100 = '1.0';
export const BaseScreenSm = '480px';
export const BaseScreenMd = '680px';
export const BaseScreenLg = '960px';
export const BaseScreenXl = '1168px';
export const BaseScreenXxl = '1360px';
export const BaseScreen3xl = '1457px';
export const BaseShadowSm = '0 2px 2px 0 rgba(0,0,0,0.1)';
export const BaseShadowMd = '0 4px 4px 0 rgba(0,0,0,0.1)';
export const BaseShadowLg = '0 6px 6px 0 rgba(0,0,0,0.3)';
export const BaseShadowXl = '4px 0 6px 0 rgba(0,0,0,0.3), -4px 0 6px 0 rgba(0,0,0,0.3)';
export const BaseSizeBorderNone = '0px';
export const BaseSizeBorderPx = '1px';
export const BaseSizeBorderSm = '2px';
export const BaseSizeBorderMd = '4px';
export const BaseSizeBorderLg = '8px';
export const BaseSizeBorderRadiusNone = '0px';
export const BaseSizeBorderRadiusXs = '2px';
export const BaseSizeBorderRadiusSm = '4px';
export const BaseSizeBorderRadiusMd = '6px';
export const BaseSizeBorderRadiusLg = '8px';
export const BaseSizeBorderRadiusXl = '12px';
export const BaseSizeBorderRadiusXxl = '16px';
export const BaseSizeBorderRadius3xl = '24px';
export const BaseSizeBorderRadiusFull = '9999px';
export const BaseSpace0 = '0px';
export const BaseSpace10 = '4px';
export const BaseSpace15 = '6px';
export const BaseSpace20 = '8px';
export const BaseSpace25 = '10px';
export const BaseSpace30 = '12px';
export const BaseSpace35 = '14px';
export const BaseSpace40 = '16px';
export const BaseSpace45 = '18px';
export const BaseSpace50 = '20px';
export const BaseSpace55 = '22px';
export const BaseSpace60 = '24px';
export const BaseSpace70 = '28px';
export const BaseSpace80 = '32px';
export const BaseSpace90 = '36px';
export const BaseSpace100 = '40px';
export const BaseSpace110 = '44px';
export const BaseSpace120 = '48px';
export const BaseSpace140 = '56px';
export const BaseSpace160 = '64px';
export const BaseSpace200 = '80px';
export const BaseSpace240 = '96px';
export const BaseSpace280 = '112px';
export const BaseSpace320 = '128px';
export const BaseSpace360 = '144px';
export const BaseSpace400 = '160px';
export const BaseSpace440 = '176px';
export const BaseSpace480 = '192px';
export const BaseSpace520 = '208px';
export const BaseSpace560 = '224px';
export const BaseSpace600 = '240px';
export const BaseSpace640 = '256px';
export const BaseSpace720 = '288px';
export const BaseSpace800 = '320px';
export const BaseSpace960 = '384px';
export const BaseSpacePx = '1px';
export const BaseSpace05 = '2px';
export const BaseTypeDecorationNone = 'none';
export const BaseTypeDecorationUnderline = 'underline';
export const BaseTypeFontSans = "'Roboto Flex', Roboto, sans-serif";
export const BaseTypeFontSansAlt = "'Roboto Flex'";
export const BaseTypeFontSerif = "'Roboto Serif', serif";
export const BaseTypeFontSerifAlt = "'Roboto Serif'";
export const BaseTypeFontMono = "'Roboto Mono', monospace";
export const BaseTypeFontMonoAlt = "'Roboto Mono'";
export const BaseTypeLeadingNone = '1';
export const BaseTypeLeadingCompact = '1.15';
export const BaseTypeLeadingTighter = '1.2';
export const BaseTypeLeadingTight = '1.25';
export const BaseTypeLeadingSnug = '1.3';
export const BaseTypeLeadingNormal = '1.5';
export const BaseTypeSizeXxs = '10px';
export const BaseTypeSizeXs = '12px';
export const BaseTypeSizeSm = '14px';
export const BaseTypeSizeMd = '16px';
export const BaseTypeSizeLg = '18px';
export const BaseTypeSizeXl = '20px';
export const BaseTypeSizeXxl = '22px';
export const BaseTypeSize3xl = '28px';
export const BaseTypeSize4xl = '32px';
export const BaseTypeSize5xl = '40px';
export const BaseTypeTrackingTighter = '-0.04em';
export const BaseTypeTrackingTight = '-0.01em';
export const BaseTypeTrackingNormal = 'normal';
export const BaseTypeTrackingWide = '0.02em';
export const BaseTypeTrackingWider = '0.04em';
export const BaseTypeTransformNormal = 'none';
export const BaseTypeTransformLowercase = 'lowercase';
export const BaseTypeTransformUppercase = 'uppercase';
export const BaseTypeTransformCapitalize = 'capitalize';
export const BaseTypeVariationWidthNarrower = '60';
export const BaseTypeVariationWidthNarrow = '80';
export const BaseTypeVariationWidthRegular = '100';
export const BaseTypeVariationWidthWide = '120';
export const BaseTypeVariationWidthWider = '140';
export const BaseTypeVariationItalicNormal = '0';
export const BaseTypeVariationItalicItalic = '1';
export const BaseTypeVariationSlantNone = '0';
export const BaseTypeVariationSlantOblique = '-12';
export const BaseTypeVariationGradeLighter = '-128';
export const BaseTypeVariationGradeLight = '-64';
export const BaseTypeVariationGradeRegular = '0';
export const BaseTypeVariationGradeHeavy = '64';
export const BaseTypeVariationGradeHeavier = '128';
export const BaseTypeWeightThin = '100';
export const BaseTypeWeightExtralight = '200';
export const BaseTypeWeightLight = '300';
export const BaseTypeWeightRegular = '400';
export const BaseTypeWeightMedium = '500';
export const BaseTypeWeightSemibold = '600';
export const BaseTypeWeightBold = '700';
export const BaseTypeWeightExtrabold = '800';
export const BaseTypeWeightBlack = '900';
export const SemColorNeutral50 = '#f4f4f4';
export const SemColorNeutral100 = '#e3e3e3';
export const SemColorNeutral200 = '#cccccc';
export const SemColorNeutral300 = '#b2b2b2';
export const SemColorNeutral400 = '#959595';
export const SemColorNeutral500 = '#828282';
export const SemColorNeutral600 = '#6d6d6d';
export const SemColorNeutral700 = '#5a5a5a';
export const SemColorNeutral800 = '#4a4a4a';
export const SemColorNeutral900 = '#333333';
export const SemColorPrimary50 = '#ebf6ff';
export const SemColorPrimary100 = '#cce8ff';
export const SemColorPrimary200 = '#a3d0f5';
export const SemColorPrimary300 = '#81b7e4';
export const SemColorPrimary400 = '#57a0db';
export const SemColorPrimary500 = '#318ad3';
export const SemColorPrimary600 = '#2372b8';
export const SemColorPrimary700 = '#005ba8';
export const SemColorPrimary800 = '#004986';
export const SemColorPrimary900 = '#003468';
export const SemColorPrimary950 = '#001b35';
export const SemColorSecondary50 = '#ebf6ff';
export const SemColorSecondary100 = '#cce8ff';
export const SemColorSecondary200 = '#a3d0f5';
export const SemColorSecondary300 = '#81b7e4';
export const SemColorSecondary400 = '#57a0db';
export const SemColorSecondary500 = '#318ad3';
export const SemColorSecondary600 = '#2372b8';
export const SemColorSecondary700 = '#005ba8';
export const SemColorSecondary800 = '#004986';
export const SemColorSecondary900 = '#003468';
export const SemColorSurfaceDefault = '#ffffff';
export const SemColorSurfaceApp = '#ffffff';
export const SemColorSurfaceSubdued = '#f4f4f4';
export const SemColorSurfaceMuted = '#e3e3e3';
export const SemColorSurfaceInverseDefault = '#4a4a4a';
export const SemColorSurfaceInverseMuted = '#5a5a5a';
export const SemColorSurfaceInfo = '#cce8ff';
export const SemColorSurfaceSuccess = '#c9eabf';
export const SemColorSurfaceCaution = '#fff0c2';
export const SemColorSurfaceError = '#ffd6cf';
export const SemColorSurfaceUrgent = '#e44941';
export const SemColorSurfaceDark = '#4a4a4a';
export const SemColorSurfaceLight = '#ffffff';
export const SemColorSurfaceInteractiveRest = '#005ba8';
export const SemColorSurfaceInteractiveHover = '#ebf6ff';
export const SemColorSurfaceInteractiveActive = '#ebf6ff';
export const SemColorSurfaceInteractiveFocus = '#ebf6ff';
export const SemColorSurfaceInteractiveDisabled = '#e3e3e3';
export const SemColorSurfaceInteractiveSelected = '#ebf6ff';
export const SemColorSurfaceInteractiveInverseRest = '#81b7e4';
export const SemColorSurfaceInteractiveInverseHover = '#001b35';
export const SemColorSurfaceInteractiveInverseActive = '#001b35';
export const SemColorSurfaceInteractiveInverseFocus = '#001b35';
export const SemColorSurfaceInteractiveInverseDisabled = '#4a4a4a';
export const SemColorSurfaceInteractiveInverseSelected = '#003468';
export const SemColorSurfaceButtonPrimaryRest = '#005ba8';
export const SemColorSurfaceButtonPrimaryHover = '#2372b8';
export const SemColorSurfaceButtonPrimaryActive = '#2372b8';
export const SemColorSurfaceButtonPrimaryFocus = '#005ba8';
export const SemColorSurfaceButtonPrimaryDisabled = '#e3e3e3';
export const SemColorSurfaceButtonSecondaryRest = 'rgba(0, 0, 0, 0)';
export const SemColorSurfaceButtonSecondaryHover = '#ebf6ff';
export const SemColorSurfaceButtonSecondaryActive = '#ebf6ff';
export const SemColorSurfaceButtonSecondaryFocus = 'rgba(0, 0, 0, 0)';
export const SemColorSurfaceButtonSecondaryDisabled = 'rgba(0, 0, 0, 0)';
export const SemColorSurfaceButtonTertiaryRest = 'rgba(0, 0, 0, 0)';
export const SemColorSurfaceButtonTertiaryHover = '#ebf6ff';
export const SemColorSurfaceButtonTertiaryActive = '#ebf6ff';
export const SemColorSurfaceButtonTertiaryFocus = 'rgba(0, 0, 0, 0)';
export const SemColorSurfaceButtonTertiaryDisabled = 'rgba(0, 0, 0, 0)';
export const SemColorOnSurfaceDefault = '#000000';
export const SemColorOnSurfaceSubdued = '#5a5a5a';
export const SemColorOnSurfaceMuted = '#6d6d6d';
export const SemColorOnSurfaceSubtle = '#959595';
export const SemColorOnSurfaceDim = '#b2b2b2';
export const SemColorOnSurfaceInverse = '#ffffff';
export const SemColorOnSurfacePrimary = '#2372b8';
export const SemColorOnSurfaceInfoDefault = '#2372b8';
export const SemColorOnSurfaceInfoMuted = '#57a0db';
export const SemColorOnSurfaceSuccessDefault = '#3c7b29';
export const SemColorOnSurfaceSuccessMuted = '#53ac39';
export const SemColorOnSurfaceCautionDefault = '#ebb000';
export const SemColorOnSurfaceCautionMuted = '#ffc20e';
export const SemColorOnSurfaceErrorDefault = '#d41e27';
export const SemColorOnSurfaceErrorMuted = '#f06f61';
export const SemColorOnSurfaceInteractiveRest = '#005ba8';
export const SemColorOnSurfaceInteractiveHover = '#005ba8';
export const SemColorOnSurfaceInteractiveActive = '#005ba8';
export const SemColorOnSurfaceInteractiveFocus = '#005ba8';
export const SemColorOnSurfaceInteractiveDisabled = '#959595';
export const SemColorOnSurfaceInteractiveSelected = '#003468';
export const SemColorOnSurfaceInteractiveInverseRest = '#ffffff';
export const SemColorOnSurfaceInteractiveInverseHover = '#ffffff';
export const SemColorOnSurfaceInteractiveInverseActive = '#ffffff';
export const SemColorOnSurfaceInteractiveInverseFocus = '#ffffff';
export const SemColorOnSurfaceInteractiveInverseDisabled = '#5a5a5a';
export const SemColorOnSurfaceInteractiveInverseSelected = '#ffffff';
export const SemColorOnSurfaceLinkRest = '#005ba8';
export const SemColorOnSurfaceLinkHover = '#318ad3';
export const SemColorOnSurfaceLinkActive = '#318ad3';
export const SemColorOnSurfaceLinkFocus = '#318ad3';
export const SemColorOnSurfaceLinkVisited = '#a9216a';
export const SemColorOnSurfaceLinkDisabled = '#959595';
export const SemColorOnSurfaceButtonPrimaryRest = '#ffffff';
export const SemColorOnSurfaceButtonPrimaryHover = '#ffffff';
export const SemColorOnSurfaceButtonPrimaryActive = '#ffffff';
export const SemColorOnSurfaceButtonPrimaryFocus = '#ffffff';
export const SemColorOnSurfaceButtonPrimaryDisabled = '#959595';
export const SemColorOnSurfaceButtonSecondaryRest = '#005ba8';
export const SemColorOnSurfaceButtonSecondaryHover = '#005ba8';
export const SemColorOnSurfaceButtonSecondaryActive = '#005ba8';
export const SemColorOnSurfaceButtonSecondaryFocus = '#005ba8';
export const SemColorOnSurfaceButtonSecondaryDisabled = '#959595';
export const SemColorOnSurfaceButtonTertiaryRest = '#005ba8';
export const SemColorOnSurfaceButtonTertiaryHover = '#005ba8';
export const SemColorOnSurfaceButtonTertiaryActive = '#005ba8';
export const SemColorOnSurfaceButtonTertiaryFocus = '#005ba8';
export const SemColorOnSurfaceButtonTertiaryDisabled = '#959595';
export const SemColorBorderDefault = '#959595';
export const SemColorBorderMax = '#000000';
export const SemColorBorderMuted = '#b2b2b2';
export const SemColorBorderInverse = '#ffffff';
export const SemColorBorderInfo = '#2372b8';
export const SemColorBorderSuccess = '#3c7b29';
export const SemColorBorderCaution = '#ebb000';
export const SemColorBorderError = '#d41e27';
export const SemColorBorderInteractiveRest = '#005ba8';
export const SemColorBorderInteractiveHover = '#005ba8';
export const SemColorBorderInteractiveActive = '#005ba8';
export const SemColorBorderInteractiveFocus = '#005ba8';
export const SemColorBorderInteractiveDisabled = '#b2b2b2';
export const SemColorBorderInteractiveSelected = '#003468';
export const SemColorBorderButtonPrimaryRest = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonPrimaryHover = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonPrimaryActive = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonPrimaryFocus = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonPrimaryDisabled = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonSecondaryRest = '#005ba8';
export const SemColorBorderButtonSecondaryHover = '#005ba8';
export const SemColorBorderButtonSecondaryActive = '#005ba8';
export const SemColorBorderButtonSecondaryFocus = '#005ba8';
export const SemColorBorderButtonSecondaryDisabled = '#b2b2b2';
export const SemColorBorderButtonTertiaryRest = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonTertiaryHover = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonTertiaryActive = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonTertiaryFocus = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonTertiaryDisabled = 'rgba(0, 0, 0, 0)';
export const SemColorBorderButtonDividerDisabled = '#b2b2b2';
export const SemColorBorderButtonDividerPrimary = '#ffffff';
export const SemColorBorderButtonDividerSecondary = '#005ba8';
export const SemColorBorderButtonDividerTertiary = 'rgba(0, 0, 0, 0)';
export const SemColorShadowDefault = '#4a4a4a';
export const SemColorShadowMuted = '#b2b2b2';
export const SemColorRingDefault = '#cce8ff';
export const SemColorOverlayDark = 'rgba(74, 74, 74, 0.8)';
export const SemColorOverlayLight = 'rgba(255, 255, 255, 0.9)';
export const SemColorOverlaySubdued = 'rgba(244, 244, 244, 0.96)';
export const SemRingDefault = '0 0 0 3px #cce8ff';
export const SemRingFocus = '0 0 0 2px #ffffff, 0 0 0 4px #005ba8';
export const SemSizeBorderButtonPrimary = '0px';
export const SemSizeBorderButtonDividerPrimary = '1px';
export const SemSizeBorderButtonSecondary = '1px';
export const SemSizeBorderButtonDividerSecondary = '1px';
export const SemSizeBorderButtonTertiary = '0px';
export const SemSizeBorderRadiusDefault = '4px';
export const SemSizeBorderRadiusRound = '9999px';
export const SemSizeBorderRadiusButton = '4px';
export const SemTypeFontHeading = "'Roboto Flex', Roboto, sans-serif";
export const SemTypeFontBody = "'Roboto Flex', Roboto, sans-serif";
export const SemTypeFontInteractiveDefault = "'Roboto Flex', Roboto, sans-serif";
export const SemTypeFontButtonDefault = "'Roboto Flex', Roboto, sans-serif";
export const SemTypeFontButtonAux = "'Roboto Flex', Roboto, sans-serif";
export const SemTypeWeightInteractiveDefault = '500';
export const SemTypeWeightButtonDefault = '600';
export const SemTypeWeightButtonAux = '400';
export const SemTypographyHeadingH1 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '28px',
  fontWeight: '700',
  letterSpacing: '-0.01em',
  lineHeight: '1.15',
  textTransform: 'none'
};
export const SemTypographyHeadingH2 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '22px',
  fontWeight: '700',
  letterSpacing: 'normal',
  lineHeight: '1.15',
  textTransform: 'none'
};
export const SemTypographyHeadingH3 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '20px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.2',
  textTransform: 'none'
};
export const SemTypographyHeadingH4 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.2',
  textTransform: 'none'
};
export const SemTypographyHeadingH5 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.2',
  textTransform: 'none'
};
export const SemTypographyHeadingH6 = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.2',
  textTransform: 'none'
};
export const SemTypographyBodyLg = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyBodyMd = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyBodySm = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyBodyXs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyBodyXxs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '10px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorBlockLg = {
  display: 'block',
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorBlockMd = {
  display: 'block',
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorBlockSm = {
  display: 'block',
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorBlockXs = {
  display: 'block',
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorBlockXxs = {
  display: 'block',
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '10px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyAnchorInlineLg = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'underline'
};
export const SemTypographyAnchorInlineMd = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'underline'
};
export const SemTypographyAnchorInlineSm = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'underline'
};
export const SemTypographyAnchorInlineXs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'underline'
};
export const SemTypographyAnchorInlineXxs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '10px',
  fontWeight: '500',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'underline'
};
export const SemTypographyLabelLg = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.15',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyLabelMd = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.15',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyLabelSm = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.15',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyListLg = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyListMd = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyListSm = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyListXs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyListXxs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '10px',
  fontWeight: '400',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyStrongLg = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '18px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyStrongMd = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '16px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.25',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyStrongSm = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '14px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyStrongXs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '12px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};
export const SemTypographyStrongXxs = {
  fontFamily: "'Roboto Flex', Roboto, sans-serif",
  fontSize: '10px',
  fontWeight: '600',
  letterSpacing: 'normal',
  lineHeight: '1.3',
  textTransform: 'none',
  textDecoration: 'none'
};